import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const companyId = () => getActiveCompanyId();

export const getEmployees = async () => {
    const res = await axiosInstance.get(`/companies/${companyId()}/employees`, {
        params: { page: 1, pageSize: 1000 }
    });
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const getEmployee = async (employeeId, cid) => {
    return (await axiosInstance.get(`/companies/${cid || companyId()}/employees/${employeeId}`)).data;
};

export const createEmployee = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/employees`, payload)).data;
};

export const updateEmployee = async ({ employeeId, _companyId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${_companyId || companyId()}/employees/${employeeId}`, payload)).data;
};

export const deleteEmployee = async (employeeId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/employees/${employeeId}`)).data;
};

export const getEmployeeBankAccounts = async (employeeId, cid) => {
    try {
        const res = (await axiosInstance.get(`/companies/${cid || companyId()}/employees/${employeeId}/bank_accounts`, { params: { cursor: '0' } })).data;
        return Array.isArray(res) ? res : (res?.data ?? []);
    } catch { return []; }
};

export const createEmployeeBankAccount = async (employeeId, { accountType, ...rest }, cid) => {
    return (await axiosInstance.post(`/companies/${cid || companyId()}/employees/${employeeId}/bank_accounts`, { subtype: accountType, ...rest })).data;
};

export const updateEmployeeBankAccount = async (employeeId, accountId, { accountType, ...rest }, cid) => {
    return (await axiosInstance.patch(`/companies/${cid || companyId()}/employees/${employeeId}/bank_accounts/${accountId}`, { subtype: accountType, ...rest })).data;
};

export const deleteEmployeeBankAccount = async (employeeId, accountId, cid) => {
    return (await axiosInstance.delete(`/companies/${cid || companyId()}/employees/${employeeId}/bank_accounts/${accountId}`)).data;
};

export const getEmployeeNetPaySplits = async (employeeId, cid) => {
    try {
        const res = (await axiosInstance.get(`/companies/${cid || companyId()}/employees/${employeeId}/net_pay_splits`, { params: { cursor: '0' } })).data;
        return Array.isArray(res) ? res : (res?.data ?? []);
    } catch { return []; }
};

export const createEmployeeNetPaySplit = async (employeeId, splits, cid) => {
    const totalPercentage = splits
        .filter((s) => s.splitType === "percentage")
        .reduce((sum, s) => sum + (parseFloat(s.value) || 0), 0);
    const remainingPercent = Math.max(0, 100 - totalPercentage);
    const mapped = splits.map((s, i) => {
        const percent =
            s.splitType === "percentage"
                ? parseFloat(s.value) || 0
                : s.splitType === "remaining_balance"
                ? remainingPercent
                : 0;
        return {
            bankAccountId: s.bankAccountId,
            priority: i + 1,
            amount: s.splitType === "flat" ? parseFloat(s.value) || 0 : 0,
            percent,
        };
    });
    return (await axiosInstance.post(`/companies/${cid || companyId()}/employees/${employeeId}/net_pay_splits`, { splits: mapped })).data;
};

export const deleteEmployeeNetPaySplit = async (employeeId, splitId, cid) => {
    return (await axiosInstance.delete(`/companies/${cid || companyId()}/employees/${employeeId}/net_pay_splits/${splitId}`)).data;
};

export const inviteEmployee = async (employeeId) =>
    (await axiosInstance.post(`/companies/${companyId()}/employees/${employeeId}/invite`)).data;

export const saveI9Section2 = async (employeeId, data) =>
    (await axiosInstance.post(`/companies/${companyId()}/employees/${employeeId}/i9-section2`, data)).data;